import { type BadgeRarity } from './badgePrestigeMapping';

// Unified prestige system for the entire application
export const PRESTIGE_TIERS: Array<{ name: string; hours: number; rarity: BadgeRarity }> = [
  // Tier 1 — Apprentice (0–999 hrs)
  { name: "Apprentice I", hours: 0, rarity: 'bronze' },
  { name: "Apprentice II", hours: 100, rarity: 'bronze' },
  { name: "Apprentice III", hours: 200, rarity: 'bronze' },
  { name: "Apprentice IV", hours: 300, rarity: 'bronze' },
  { name: "Apprentice V", hours: 400, rarity: 'bronze' },
  { name: "Apprentice VI", hours: 500, rarity: 'bronze' },
  { name: "Apprentice VII", hours: 600, rarity: 'bronze' },
  { name: "Apprentice VIII", hours: 700, rarity: 'bronze' },
  { name: "Apprentice IX", hours: 800, rarity: 'bronze' },
  { name: "Apprentice X", hours: 900, rarity: 'bronze' },

  // Tier 2 — Journeyman (1000–1999 hrs)
  { name: "Journeyman I", hours: 1000, rarity: 'silver' },
  { name: "Journeyman II", hours: 1100, rarity: 'silver' },
  { name: "Journeyman III", hours: 1200, rarity: 'silver' },
  { name: "Journeyman IV", hours: 1300, rarity: 'silver' },
  { name: "Journeyman V", hours: 1400, rarity: 'silver' },
  { name: "Journeyman VI", hours: 1500, rarity: 'silver' },
  { name: "Journeyman VII", hours: 1600, rarity: 'silver' },
  { name: "Journeyman VIII", hours: 1700, rarity: 'silver' },
  { name: "Journeyman IX", hours: 1800, rarity: 'silver' },
  { name: "Journeyman X", hours: 1900, rarity: 'silver' },

  // Tier 3 — Seeker
  { name: "Seeker I", hours: 2000, rarity: 'silver' },
  { name: "Seeker II", hours: 2100, rarity: 'silver' },
  { name: "Seeker III", hours: 2200, rarity: 'silver' },
  { name: "Seeker IV", hours: 2300, rarity: 'silver' },
  { name: "Seeker V", hours: 2400, rarity: 'silver' },
  { name: "Seeker VI", hours: 2500, rarity: 'silver' },
  { name: "Seeker VII", hours: 2600, rarity: 'silver' },
  { name: "Seeker VIII", hours: 2700, rarity: 'silver' },
  { name: "Seeker IX", hours: 2800, rarity: 'silver' },
  { name: "Seeker X", hours: 2900, rarity: 'silver' },

  // Tier 4 — Scholar
  { name: "Scholar I", hours: 3000, rarity: 'gold' },
  { name: "Scholar II", hours: 3100, rarity: 'gold' },
  { name: "Scholar III", hours: 3200, rarity: 'gold' },
  { name: "Scholar IV", hours: 3300, rarity: 'gold' },
  { name: "Scholar V", hours: 3400, rarity: 'gold' },
  { name: "Scholar VI", hours: 3500, rarity: 'gold' },
  { name: "Scholar VII", hours: 3600, rarity: 'gold' },
  { name: "Scholar VIII", hours: 3700, rarity: 'gold' },
  { name: "Scholar IX", hours: 3800, rarity: 'gold' },
  { name: "Scholar X", hours: 3900, rarity: 'gold' },

  // Tier 5 — Expert
  { name: "Expert I", hours: 4000, rarity: 'gold' },
  { name: "Expert II", hours: 4100, rarity: 'gold' },
  { name: "Expert III", hours: 4200, rarity: 'gold' },
  { name: "Expert IV", hours: 4300, rarity: 'gold' },
  { name: "Expert V", hours: 4400, rarity: 'gold' },
  { name: "Expert VI", hours: 4500, rarity: 'gold' },
  { name: "Expert VII", hours: 4600, rarity: 'gold' },
  { name: "Expert VIII", hours: 4700, rarity: 'gold' },
  { name: "Expert IX", hours: 4800, rarity: 'gold' },
  { name: "Expert X", hours: 4900, rarity: 'gold' },

  // Tier 6 — Mentor
  { name: "Mentor I", hours: 5000, rarity: 'gold' },
  { name: "Mentor II", hours: 5100, rarity: 'gold' },
  { name: "Mentor III", hours: 5200, rarity: 'gold' },
  { name: "Mentor IV", hours: 5300, rarity: 'gold' },
  { name: "Mentor V", hours: 5400, rarity: 'gold' },
  { name: "Mentor VI", hours: 5500, rarity: 'gold' },
  { name: "Mentor VII", hours: 5600, rarity: 'gold' },
  { name: "Mentor VIII", hours: 5700, rarity: 'gold' },
  { name: "Mentor IX", hours: 5800, rarity: 'gold' },
  { name: "Mentor X", hours: 5900, rarity: 'gold' },

  // Tier 7 — Master
  { name: "Master I", hours: 6000, rarity: 'gold' },
  { name: "Master II", hours: 6100, rarity: 'gold' },
  { name: "Master III", hours: 6200, rarity: 'gold' },
  { name: "Master IV", hours: 6300, rarity: 'gold' },
  { name: "Master V", hours: 6400, rarity: 'gold' },
  { name: "Master VI", hours: 6500, rarity: 'gold' },
  { name: "Master VII", hours: 6600, rarity: 'gold' },
  { name: "Master VIII", hours: 6700, rarity: 'gold' },
  { name: "Master IX", hours: 6800, rarity: 'gold' },
  { name: "Master X", hours: 6900, rarity: 'gold' },

  // Tier 8 — Grandmaster
  { name: "Grandmaster I", hours: 7000, rarity: 'legend' },
  { name: "Grandmaster II", hours: 7100, rarity: 'legend' },
  { name: "Grandmaster III", hours: 7200, rarity: 'legend' },
  { name: "Grandmaster IV", hours: 7300, rarity: 'legend' },
  { name: "Grandmaster V", hours: 7400, rarity: 'legend' },
  { name: "Grandmaster VI", hours: 7500, rarity: 'legend' },
  { name: "Grandmaster VII", hours: 7600, rarity: 'legend' },
  { name: "Grandmaster VIII", hours: 7700, rarity: 'legend' },
  { name: "Grandmaster IX", hours: 7800, rarity: 'legend' },
  { name: "Grandmaster X", hours: 7900, rarity: 'legend' },

  // Tier 9 — Sage
  { name: "Sage I", hours: 8000, rarity: 'legend' },
  { name: "Sage II", hours: 8100, rarity: 'legend' },
  { name: "Sage III", hours: 8200, rarity: 'legend' },
  { name: "Sage IV", hours: 8300, rarity: 'legend' },
  { name: "Sage V", hours: 8400, rarity: 'legend' },
  { name: "Sage VI", hours: 8500, rarity: 'legend' },
  { name: "Sage VII", hours: 8600, rarity: 'legend' },
  { name: "Sage VIII", hours: 8700, rarity: 'legend' },
  { name: "Sage IX", hours: 8800, rarity: 'legend' },
  { name: "Sage X", hours: 8900, rarity: 'legend' },

  // Tier 10 — Legend (9,000–10,000 hrs)
  { name: "Legend I", hours: 9000, rarity: 'legend' },
  { name: "Legend II", hours: 9100, rarity: 'legend' },
  { name: "Legend III", hours: 9200, rarity: 'legend' },
  { name: "Legend IV", hours: 9300, rarity: 'legend' },
  { name: "Legend V", hours: 9400, rarity: 'legend' },
  { name: "Legend VI", hours: 9500, rarity: 'legend' },
  { name: "Legend VII", hours: 9600, rarity: 'legend' },
  { name: "Legend VIII", hours: 9700, rarity: 'legend' },
  { name: "Legend IX", hours: 9800, rarity: 'legend' },
  { name: "Legend X", hours: 9900, rarity: 'legend' },

  { name: "Genius", hours: 10000, rarity: 'legend' },
];

export const getPrestigeTitle = (hours: number): string => {
  for (let i = PRESTIGE_TIERS.length - 1; i >= 0; i--) {
    if (hours >= PRESTIGE_TIERS[i].hours) {
      return PRESTIGE_TIERS[i].name;
    }
  }
  return "Apprentice I";
};

export const getCurrentPrestigeTier = (hours: number) => {
  for (let i = PRESTIGE_TIERS.length - 1; i >= 0; i--) {
    if (hours >= PRESTIGE_TIERS[i].hours) {
      return PRESTIGE_TIERS[i];
    }
  }
  return PRESTIGE_TIERS[0];
};

export const getNextPrestigeTier = (hours: number) => {
  const currentIndex = PRESTIGE_TIERS.findIndex((tier, i) => 
    hours >= tier.hours && (i === PRESTIGE_TIERS.length - 1 || hours < PRESTIGE_TIERS[i + 1].hours)
  );
  
  if (currentIndex === -1 || currentIndex === PRESTIGE_TIERS.length - 1) {
    return PRESTIGE_TIERS[PRESTIGE_TIERS.length - 1];
  }
  
  return PRESTIGE_TIERS[currentIndex + 1];
};

export const getPrestigeProgress = (hours: number) => {
  const current = getCurrentPrestigeTier(hours);
  const next = getNextPrestigeTier(hours);
  
  if (current === next) {
    return 100; // Max tier reached
  }
  
  const progress = ((hours - current.hours) / (next.hours - current.hours)) * 100;
  return Math.min(100, Math.max(0, progress));
};